import {computed, useCookie, useState} from '#imports';

export const useStoredKeys = () => useState<Set<string>>('stored-keys', () => new Set<string>());

const toolCookieOptions = {
    // Cookies written before this fix were JSON-encoded by Nuxt ("1" with quotes), so both forms must stay readable
    encode: (isActive?: boolean) => (isActive ? '1' : '0'),
    decode: (value: string) => ['1', '"1"'].includes(decodeURIComponent(value)),
};

export function useTranslationAdminTools() {
    // Cookies keep the state identical between SSR and CSR, which avoids hydration mismatches on the toggles
    const debugCookie = useCookie<boolean | undefined>('nuxt-i18n-module-debug', toolCookieOptions);
    const logsCookie = useCookie<boolean | undefined>('nuxt-i18n-module-logs', toolCookieOptions);

    // Computed so the toggles react to switch* without a manual local copy
    const isActivatedDebugTool = computed(() => !!debugCookie.value);
    const isActivatedLogsTool = computed(() => !!logsCookie.value);

    function switchDebugTool(isActive: boolean) {
        debugCookie.value = isActive;
    }
    function switchLogsTool(isActive: boolean) {
        logsCookie.value = isActive;
    }

    return {
        isActivatedDebugTool,
        isActivatedLogsTool,
        switchDebugTool,
        switchLogsTool,
    };
}
